module.exports = __webpack_public_path__ + "static/media/screen-location-background.ee9c3bef.svg";